import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20wallpaper%20pattern%2C%20soft%20warm%20cream%20background%20with%20subtle%20comic%20panel%20line%20art%20overlay%2C%20elegant%20minimal%20illustration%20style%2C%20gentle%20gradient%20from%20cream%20to%20warm%20beige%2C%20abstract%20manga%20speed%20lines%2C%20sophisticated%20atmosphere%2C%20no%20characters%2C%20textured%20paper%20effect&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫网背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold tracking-wider mb-5 uppercase">
              人气韩漫大全
            </span>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-5">
              免费韩国漫画
              <br />
              <span className="text-accent-400">在线阅读平台</span>
            </h1>
            <p className="text-base md:text-lg text-foreground-200 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              海量高清韩漫资源，每日更新热门连载。随时随地，畅享漫画世界。全站免费，无需付费订阅。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                立即阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 border border-foreground-300/50 text-foreground-100 hover:bg-foreground-50/10 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-8 mt-10 justify-center lg:justify-start flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">10,000+</div>
                <div className="text-xs text-foreground-400 mt-1">漫画资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">50万+</div>
                <div className="text-xs text-foreground-400 mt-1">日活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">每日更新</div>
                <div className="text-xs text-foreground-400 mt-1">热门连载</div>
              </div>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center">
            <div className="relative w-80 h-[480px]">
              <div className="absolute -top-4 -left-4 w-72 h-[440px] rounded-2xl overflow-hidden border-2 border-foreground-300/20 rotate-[-6deg]">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20beautiful%20couple%20embracing%2C%20soft%20warm%20lighting%2C%20elegant%20illustration%20style%2C%20cream%20and%20rose%20tones%2C%20romantic%20atmosphere%2C%20webtoon%20cover%20aesthetic%2C%20delicate%20linework&width=600&height=800&seq=hero-comic-left&orientation=portrait"
                  alt="韩漫推荐"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-2 -right-4 w-72 h-[440px] rounded-2xl overflow-hidden border-2 border-foreground-300/20 rotate-[4deg] z-10">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%2C%20epic%20warrior%20with%20sword%2C%20dramatic%20lighting%2C%20golden%20and%20crimson%20accents%2C%20dynamic%20composition%2C%20webtoon%20cover%20art%2C%20intense%20atmosphere&width=600&height=800&seq=hero-comic-right&orientation=portrait"
                  alt="人气韩漫"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-4 left-8 w-72 h-[440px] rounded-2xl overflow-hidden border-2 border-foreground-300/20 rotate-[2deg] z-20">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%2C%20detective%20noir%20style%2C%20dark%20urban%20setting%2C%20moody%20blue%20and%20warm%20accent%20tones%2C%20suspenseful%20webtoon%20cover%2C%20cinematic%20composition&width=600&height=800&seq=hero-comic-center&orientation=portrait"
                  alt="韩漫推荐"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-foreground-300 text-2xl"></i>
      </div>
    </section>
  );
}